function isElementNOTInArray(payload) {
  return !payload.array.find(
    (summaryEl) =>
      summaryEl[payload.item].trim() == payload.element[payload.item].trim()
  );
}

function isSelectedSoapCategory(payload, element){
  return (payload.soap.trim() == element.soap.trim()) || (payload.soap == "All Soaps");
}

export default {
  async topTenCriminals(context, payload) {
    let summaryArray = [];

    // pull out each unique criminal name from data per soap if specific soap
    // defined in payload if already in summary array increase count by 1
    context.state.CrimeData.forEach((element, index) => {
      
      if (
        isElementNOTInArray({
          array: summaryArray,
          item: "villain",
          element: element,
        })
      ) {
        if (isSelectedSoapCategory(payload, element)) {
          let crimeArray = [];
          crimeArray.push({crime: element.crime, sentence: element.sentence});
          summaryArray.push({
            villain: element.villain,
            soap: element.soap,
            count: 1,
            image: element.image,
            crimes : crimeArray,
            sentence : element.sentence,
          });
        }
      } else if (isSelectedSoapCategory(payload, element)){
        index = summaryArray.findIndex(
          (summaryEl) => summaryEl.villain == element.villain
        );
        summaryArray[index].count = summaryArray[index].count + 1;
        summaryArray[index].crimes.push({crime: element.crime, sentence: element.sentence});
        summaryArray[index].sentence = summaryArray[index].sentence + element.sentence;
      }
    });

    //order array in descending order by count and pull 'TopNumber' values from array
    summaryArray = summaryArray.sort((a, b) => b.count - a.count);
    let TopNumber = 10;
    // if (context.state.criminalsSoap == "All Soaps") { TopNumber = 10;}
    context.commit("setTopTenCriminals", {
      value: summaryArray.slice(0, TopNumber),
    });

    //order array in descending order by sentence and pull 'TopNumber' values from array
    summaryArray = summaryArray.sort((a, b) => b.sentence - a.sentence);
    let TopSentence = 10;
    // if (context.state.sentencesSoap == "All Soaps") { TopSentence = 10;}
    context.commit("setTopTenSentences", {
      value: summaryArray.slice(0, TopSentence),
    });
  },
  async topTenCrimes(context, payload) {
    let summaryArray = [];

    //pull out each unique crime from data
    context.state.AllCrimesData.forEach((element, index) => {
      if (
        isElementNOTInArray({
          array: summaryArray,
          item: "crime",
          element: element,
        }) && (isSelectedSoapCategory(payload, element))
      ) {
        summaryArray.push({ crime: element.crime, count: element.count });
      } else if (isSelectedSoapCategory(payload, element)){
        index = summaryArray.findIndex(
          (summaryEl) => summaryEl.crime == element.crime
        );
        summaryArray[index].count = summaryArray[index].count + element.count;
      }
    });
    
    //order array in descending order by count
    summaryArray = summaryArray.sort((a, b) => b.count - a.count);
    const TopNumber = 10;
    context.commit("setTopTenCrimes", {
      value: summaryArray.slice(0, TopNumber),
    });
  },
};
